/*
 * ------------------------------------------------------------------------------------
 * DESCRIPTION:
 * ------------------------------------------------------------------------------------
 *      LineBehind component
 *
 * ------------------------------------------------------------------------------------
 * VERSION HISTORY: (NOTE: The version variables must be updated manually.)
 * ------------------------------------------------------------------------------------
 *                   Changed By
 *      Date         Initials    Version #  Sub-Version  Notes
 *      -----------  ----------  ---------  -----------  ------------------------------
 *      2022-11-16   BL          22320      1            Re-structured files and renamed to index.js
 *
 */
import React from "react";
import styled from "styled-components";

const LineBehind = ({
    className = "w-100 text-center",
    textClassName = "bg-white px-2",
    text = "or",
}) => {
    return (
        <Background className={className}>
            <span className={textClassName}>{text}</span>
        </Background>
    );
};

const Background = styled.div`
    position: relative;
    z-index: 0;
    &:before {
        border-top: 2px solid #dfdfdf;
        content: "";
        margin: 0 auto; /* this centers the line to the full width specified */
        position: absolute; /* positioning must be absolute here, and relative positioning must be applied to the parent */
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 95%;
        z-index: -1;
    }
`;

export default LineBehind;
